module.exports = __webpack_public_path__ + "img/icon-google_v2.3f28e470.svg";